// extracted by mini-css-extract-plugin
module.exports = {"applePayButton":"apple-pay-button_applePayButton__6_PDw"};